import { watchAddNewDealerRequestCompleteEvent } from './addNewDealerRequestCompleteEvent';
import { watchAddNewDealerRequestEvent } from './addNewDealerRequestEvent';
import { watchAdvanceNewDealerState } from './advanceNewDealerState';
import { watchCompleteNewDealerRequest } from './completeNewDealerRequest';
import { watchCreateNewDealerCustomer } from './createNewDealerCustomer';
import { watchDeleteNewDealerCart } from './deleteNewDealerCart';
import { watchDeleteNewDealerRequestCompleteEvent } from './deleteNewDealerRequestCompleteEvent';
import { watchDeleteNewDealerRequestEvent } from './deleteNewDealerRequestEvent';
import { watchFetchNewDealerRequest } from './fetchNewDealerRequest';
import { watchFetchNewDealerRequests } from './fetchNewDealerRequests';
import { watchImportNewDealerOrders } from './importNewDealerOrders';
import { watchRejectNewDealerRequest } from './rejectNewDealerRequest';
import { watchSearchNewDealerCatalog } from './searchCatalog';
import { watchUpdateNewDealerCart } from './updateNewDealerCart';
import { watchUpdateNewDealerRequest } from './updateNewDealerRequest';
import { watchValidateNewDealerRequest } from './validateNewDealerRequest';

export const newDealerSagas = [
  watchAddNewDealerRequestCompleteEvent(),
  watchAddNewDealerRequestEvent(),
  watchAdvanceNewDealerState(),
  watchCompleteNewDealerRequest(),
  watchCreateNewDealerCustomer(),
  watchDeleteNewDealerCart(),
  watchDeleteNewDealerRequestCompleteEvent(),
  watchDeleteNewDealerRequestEvent(),
  watchFetchNewDealerRequest(),
  watchFetchNewDealerRequests(),
  watchImportNewDealerOrders(),
  watchRejectNewDealerRequest(),
  watchSearchNewDealerCatalog(),
  watchUpdateNewDealerCart(),
  watchUpdateNewDealerRequest(),
  watchValidateNewDealerRequest()
];
